export const getButtonWidth = (fullWidth: boolean, minimumWidth: boolean): string => {
  if (minimumWidth) {
    return 'sm:max-w-xs'
  }
  if (!fullWidth) {
    return 'sm:w-328'
  }
  return ''
}